import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { JSON_BASE_URL } from "../Config/Config";
import { Spin } from "antd";

import Swal from "sweetalert2";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const DemoApplicationlist = () => {
  const [loading, setLoading] = useState(false);

 

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.localeCompare(b.Name),
      render: (text) => (
        <span title={text}>
          {text?.length > 25
            ? text.substring(0, 25) + "..."
            : text}
        </span>
      ),
    },
  
    {
      title: "Email",
      dataIndex: "EmailID",
      sorter: (a, b) =>
        a.EmailID.localeCompare(b.EmailID),
    },
  
    {
      title: "Mobile",
      dataIndex: "Number",
      sorter: (a, b) =>
        a.Number.localeCompare(b.Number),
    },
  
    {
      title: "Visited On",
      dataIndex: "CreatedOn",
      sorter: (a, b) =>
        new Date(a.CreatedOn) - new Date(b.CreatedOn),
  
      render: (text) => {
        if (!text) return "-";
  
        const date = new Date(text);
  
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
  
        return `${day}-${month}-${year}`;
      },
    },
  
    {
        title: "Note",
        dataIndex: "Notes",
      
        render: (text) =>
          text ? (
            <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2">
              {text}
            </span>
          ) : (
            "-"
          ),
      },
      {
        title: "Count",
        dataIndex: "Count",
        sorter: (a, b) =>
          a.Number.localeCompare(b.Number),
      },
  
    {
      title: "Actions",
  
      render: (_, record) => (
        <div className="action-icon d-inline-flex align-items-center">
  
          <Link
            to="#"
            className="p-2 d-flex align-items-center border rounded me-2"
            onClick={() => deleteDemoUser(record.ID)}
            
          >
            <i className="ti ti-trash text-danger" />
          </Link>
  
        </div>
      ),
    },
  ];

  const [demoUsers, setDemoUsers] = useState([]);

  const sortedDemoUsers = [...demoUsers].sort(
    (a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn)
  );

  const getDemoUsers = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${JSON_BASE_URL}/api/getDemoUsers`);

      const data = await response.json();

      if (data.status === true) {
        setDemoUsers(data.data || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDemoUsers();
  }, []);

  const deleteDemoUser = async (id) => {

   
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await fetch(
        `${JSON_BASE_URL}/api/Delete/${id}`,
        {
          method: "DELETE",
        }
      );

      const data = await response.json();

      if (data.status === true) {
        Swal.fire("Deleted!", "User deleted successfully.", "success");

        getDemoUsers();
      } else {
        Swal.fire("Error", data.message || "Delete failed", "error");
      }
    } catch (error) {
      console.log(error);

      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };



  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>WebSite Visits </h4>
                <h6>Manage your Demo WebSite Visited list </h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* <li>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Refresh"
                  >
                    <i data-feather="rotate-ccw" className="feather-rotate-ccw" />
                  </Link>
                </li> */}
              <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              <li>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                >
                  <i data-feather="chevron-up" className="feather-chevron-up" />
                </Link>
              </li>
            </ul>
          </div>

          {/* <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <div className="search-set"></div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table
                      rowKey={(record, index) => index}
                      columns={columns}
                      dataSource={sortedDemoUsers}
                      pgno={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div> */}

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <h5 className="mb-3">Visit List</h5>
              <div className="search-set"></div>

              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table columns={columns} dataSource={sortedDemoUsers}  pgno={true} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </>
  );
};

export default DemoApplicationlist;
